var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvaArrowBackFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 9.16666H5.95016L8.97516 5.53333C9.11661 5.36315 9.18466 5.14375 9.16435 4.92339C9.14403 4.70304 9.03701 4.49978 8.86683 4.35833C8.69665 4.21688 8.47725 4.14883 8.25689 4.16915C8.03654 4.18946 7.83328 4.29648 7.69183 4.46666L3.52516 9.46666C3.49713 9.50643 3.47206 9.54821 3.45016 9.59166C3.45016 9.63333 3.45016 9.65833 3.39183 9.7C3.35406 9.79554 3.33428 9.89725 3.3335 10C3.33428 10.1027 3.35406 10.2044 3.39183 10.3C3.39183 10.3417 3.39183 10.3667 3.45016 10.4083C3.47206 10.4518 3.49713 10.4936 3.52516 10.5333L7.69183 15.5333C7.77018 15.6274 7.8683 15.703 7.9792 15.7549C8.0901 15.8067 8.21107 15.8335 8.3335 15.8333C8.52821 15.8337 8.7169 15.7659 8.86683 15.6417C8.95121 15.5717 9.02096 15.4858 9.07209 15.3888C9.12322 15.2919 9.15471 15.1858 9.16478 15.0766C9.17484 14.9675 9.16327 14.8574 9.13073 14.7528C9.0982 14.6481 9.04533 14.5509 8.97516 14.4667L5.95016 10.8333H15.8335C16.0545 10.8333 16.2665 10.7455 16.4228 10.5893C16.579 10.433 16.6668 10.221 16.6668 10C16.6668 9.77898 16.579 9.56702 16.4228 9.41074C16.2665 9.25446 16.0545 9.16666 15.8335 9.16666Z",
    fill: "#FAF6EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaArrowBackFill);
export default __webpack_public_path__ + "static/media/eva_arrow-back-fill.5053fbc2123836c4dd3eeab17e19c48d.svg";
export { ForwardRef as ReactComponent };